import { useQuery } from '@tanstack/react-query';

import CrmService from '@/services/CrmService';

export const CRM_QUERY_KEY = ['crm'];

export function useGetCrm(id: number) {
  const { data, isFetching } = useQuery({
    queryKey: [...CRM_QUERY_KEY, id],
    enabled: !!id,
    queryFn: () => CrmService.findOne(id),
  });

  return {
    crm: data,
    isLoading: isFetching,
  };
}
